// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__Vrlp1","leftButtons":"nav_leftButtons__Ij2-x","rightButtons":"nav_rightButtons__OAoNI"};